<template>
    <router-link v-if="product" :to="link">
        <div v-if="product.productIntro" class="image_wrapper">
            <img v-if="product.productIntro.featured" :src="product.productIntro.featured">
        </div>
        <h3 v-if="product.productIntro && product.productIntro.info && product.productIntro.info.name">
            {{ product.productIntro.info.name }}
        </h3>
    </router-link>
</template>
<script>
export default {
    props: ["link"],
    computed: {
        product() {
            return this.$store.getters.product(this.link);
        }
    },
}
</script>